<template>
	<div>
		<div class="actDiv">
			<a-button size="small"  icon="plus" @click="showAddWindow">新增片区</a-button>
		</div>
		<a-table size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pId" :pagination="false" :scroll="{y:600}">
			<span slot="theAction" slot-scope="text, record">
			      <a-button size="small" type="link" @click="viewContent(record)">查看</a-button>
				  <a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(record)">
						<a-button size="small" type="link">删除</a-button>
				  </a-popconfirm>
			</span>
		</a-table>
		<a-drawer title="新增片区" :visible="addFlag"  width="600" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddDepart @cancelAdd="onAddClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="片区详情" :visible="viewFlag" width="640" @close="onViewClose" :destroyOnClose='true'>
			<ShowDepart :theObj="viewObj" />
		</a-drawer>
	</div>
</template>

<script>
	const columns = [
		{
			title: '片区',
			dataIndex: 'departmentName',
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pId',
		    scopedSlots: { customRender: 'theAction' },
			width:130,
			className:'v-cell',
			align:'center',
		  },
	];
	import AddDepart from '../components/AddDepart.vue'
	import ShowDepart from '../components/ShowDepart.vue'
	export default {
		components:{
			AddDepart,
			ShowDepart,
		},
		data(){
			return{
				columns,
				addFlag:false,
				viewFlag:false,
				loading:false,
				viewObj:{},
				list:[],
			}
		},
		methods:{
			onAddClose:function(){
				this.addFlag = false;
			},
			showAddWindow:function(){
				this.addFlag = true;
			},
			onViewClose:function(){
				this.viewFlag = false;
			},
			viewContent:function(item){
				this.viewObj = this.Config.deepClone(item);
				this.viewFlag = true;
			},
			deleteContent:function(item){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_DELETE_URL);
				let param = {departId:item.pId,neighborIds:item.neighborIds};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
